import { format, parseISO } from 'date-fns'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FiletypePdf, FiletypeXlsx, Search } from 'react-bootstrap-icons'
import * as XLSX from 'xlsx'
import { CustomButton } from '../../components/CustomButton'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { formatDate } from '../../utils/formatDate'
import { formatPrice } from '../../utils/formatPrice'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

//pdfMake.addVirtualFileSystem(pdfFonts)

const RelatorioRT = () => {
  const [dadosRt, setRt] = useState([])
  const [dataInicial, setDataInicial] = useState('')
  const [dataFinal, setDataFinal] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  async function listarRt() {
    const dataInicialFormatada = format(parseISO(dataInicial), 'dd.MM.yyyy')
    const dataFinalFormatada = format(parseISO(dataFinal), 'dd.MM.yyyy')

    try {
      setIsLoading(true)

      const response = await apinode.get(`/rt/${localStorage.idconta}`, {
        params: {
          data1: dataInicialFormatada,
          data2: dataFinalFormatada,
        },
      })

      setRt(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível concluir a operação!')
    } finally {
      setIsLoading(false)
    }
  }

  function gerarRelatorioPDF() {
    const data = [
      [
        {
          text: 'Pedido',
          style: 'tableRow',
        },
        {
          text: 'Arquiteto',
          style: 'tableRow',
        },
        {
          text: 'Data',
          style: 'tableRow',
        },
        {
          text: 'Valor',
          style: 'tableRow',
        },
        {
          text: 'Pagamento',
          style: 'tableRow',
        },
        {
          text: 'RT',
          style: 'tableRow',
        },
        {
          text: 'Valor RT',
          style: 'tableRow',
        },
      ],
    ]

    dadosRt.forEach((item) => {
      const dataFormatada = formatDate(item.DATA)
      const valorFormatado = formatPrice(item.VALOR)

      data.push([
        {
          text: item.PEDIDO,
          style: 'tableRow',
        },
        {
          text: item.ARQUITETO,
          style: 'tableRow',
        },
        {
          text: dataFormatada,
          style: 'tableRow',
        },
        {
          text: valorFormatado,
          style: 'tableRow',
        },
        {
          text: item.PAGAMENTO || 'N/I',
          style: 'tableRow',
        },
        {
          text: `${item.PORC_RT}%` || 'N/I',
          style: 'tableRow',
        },
        {
          text: formatPrice((item.VALOR * item.PORC_RT) / 100),
          style: 'tableRow',
        },
      ])
    })

    const dataHoraGeracao = new Date().toLocaleString('pt-BR')

    const docDefinition = {
      content: [
        {
          text: 'ZIphub Automação de Ecommerce',
          style: 'header',
          alignment: 'center',
          fontSize: 20,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        {
          text: `Data e Hora de Geração: ${dataHoraGeracao}`,
          style: 'subheader',
          alignment: 'center',
          fontSize: 12,
          color: '#777',
          margin: [0, 0, 0, 20],
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: data,
          },
          layout: 'lightHorizontalLines',
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          color: '#007bff', // Cor do cabeçalho
          margin: [0, 0, 0, 10], // Margem inferior do cabeçalho
        },
        subheader: {
          fontSize: 12,
          alignment: 'center',
          color: '#777', // Cor do subcabeçalho
          margin: [0, 0, 0, 10], // Margem inferior do subcabeçalho
        },
        tableRow: {
          fontSize: 8,
        },
      },
    }

    pdfMake.createPdf(docDefinition).open()
  }

  function gerarRelatorioExcel() {
    const dadosFormatted = dadosRt.map((dado) => ({
      Pedido: dado.PEDIDO,
      Arquiteto: dado.ARQUITETO,
      Data: formatDate(dado.DATA),
      Valor: formatPrice(dado.VALOR),
      Pagamento: dado.PAGAMENTO || 'N/I',
      RT: `${dado.PORC_RT}%` || 'N/I',
      'Valor RT': formatPrice((dado.VALOR * dado.PORC_RT) / 100),
    }))

    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(dadosFormatted)

    XLSX.utils.book_append_sheet(workbook, worksheet, 'RT')

    XLSX.writeFile(workbook, 'rt.xlsx')
  }

  return (
    <>
      <Navbar />
      <div className="container-fluid mt-page form-pedido-editar">
        <div className="row col-lg-12 offset-lg-12">
          <h2 className="d-inline mb-5">Relatório de RT</h2>
          <div className="col-6">
            <form>
              <div className="row">
                <div className="col">
                  <label
                    htmlFor="dataInicial"
                    className="form-label"
                  >
                    Data Inicial
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="dataInicial"
                    value={dataInicial}
                    onChange={(e) => setDataInicial(e.target.value)}
                  />
                </div>
                <div className="col">
                  <label
                    htmlFor="dataFinal"
                    className="form-label"
                  >
                    Data Final
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="dataFinal"
                    value={dataFinal}
                    onChange={(e) => setDataFinal(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mb-0 align-self-end">
                  <CustomButton
                    onClick={listarRt}
                    title="Pesquisar"
                    isLoading={isLoading}
                    isLoadingText={'Pesquisando...'}
                  >
                    <Search />
                  </CustomButton>
                </div>
              </div>
            </form>
          </div>

          <Row
            className="mt-4"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Col
              style={{
                display: 'flex',
              }}
            >
              <CustomButton
                onClick={gerarRelatorioPDF}
                title="Gerar PDF"
                color="#b51308"
                isDisabled={dadosRt.length === 0}
              >
                <FiletypePdf size={20} />
              </CustomButton>

              <CustomButton
                onClick={gerarRelatorioExcel}
                title="Gerar Excel"
                color="#0a592b"
                isDisabled={dadosRt.length === 0}
              >
                <FiletypeXlsx size={20} />
              </CustomButton>
            </Col>
          </Row>
        </div>

        <div className="row justify-content-center mt-4">
          {isLoading ? (
            <CustomSpinner />
          ) : (
            <>
              {dadosRt.length > 0 && (
                <div className="col">
                  <table className="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Pedido</th>
                        <th>Arquiteto</th>
                        <th>Data</th>
                        <th>Valor</th>
                        <th>Pagamento</th>
                        <th>RT</th>
                        <th>Valor RT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(dadosRt)}
                      {dadosRt.map((item) => (
                        <tr key={item.PEDIDO}>
                          <td>{item.PEDIDO}</td>
                          <td>{item.ARQUITETO}</td>
                          <td>{formatDate(item.DATA)}</td>
                          <td>{formatPrice(item.VALOR)}</td>
                          <td>{item.PAGAMENTO || 'N/I'}</td>
                          <td>{`${item.PORC_RT}%` || 'N/I'}</td>
                          <td>
                            {formatPrice((item.VALOR * item.PORC_RT) / 100)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default RelatorioRT
